import classnames from 'classnames'
import type { VFC } from 'react'

import './XsellShippingPrice.scss'

type Props = {
  shippingPrice: string
  sellerId: string
}
const XsellShippingPrice: VFC<Props> = ({ shippingPrice }) => {
  const priceAsNumber = parseFloat(
    String(shippingPrice).replace(',', '.')
  ).toFixed(2)
  const priceFormatted = `€ ${priceAsNumber.replace('.', ',')}`

  const isShippingPriceFree = shippingPrice === '0,00'

  const shippingPriceText = isShippingPriceFree
    ? 'Versandkostenfrei'
    : `zzgl. ${priceFormatted} Versandkosten`

  return (
    <div className="xsellShippingPrice">
      <div
        className={classnames(
          'xsellShippingPrice--text u-padding-small--top a-p8 u-color--grey',
          {
            'xsellShippingPrice__freeShipping': isShippingPriceFree,
          }
        )}
      >
        {shippingPriceText}
      </div>
    </div>
  )
}

export default XsellShippingPrice
